<template>
  <div>
    <div class="meter-container">
      <span id="rule-meter">
        <p v-for="cBar of colorBar" :key="cBar" v-bind:class="['valid_rule', strengthMeterCss]" ></p>
        <p v-for="gBar of grayBar" :key="gBar+10" v-bind:class="['default-bar']" ></p>
      </span>
      <span id="rule-msg">
        {{$t(this.passwordStrengthText)}}
      </span>
    </div>
  </div>
</template>

<script>
import * as validate from '../js/validation.js'

export default {
  data: () => ({
    ruleLength: false,
    ruleUpperCase: false,
    ruleLowerCase: false,
    ruleNumbers: false,
    ruleSpecialCharacter: false,
    ruleBannedCharacter: false,
    strengthMeterCss: '',
    passwordStrengthText: '',
    colorBar: 0,
    grayBar: 6,
    hasInvalidChar: true,
    additionValidationCounter: 0,
    hint: false
  }),
  props: {
    password: {
      type: String
    },
    firstName: {
      type: String
    },
    lastName: {
      type: String
    },
    userName: {
      type: String
    }
  },
  mounted: function () {
    this.onPasswordChange()
  },
  watch: {
    password: {
      handler () {
        this.onPasswordChange()
      }
    }
  },
  methods: {
    onPasswordChange: function () {
      this.validationMeter(this.password)
    },

    validationMeter: function (password) {
      this.colorBar = 0
      this.grayBar = 6
      this.hasInvalidChar = true
      this.additionValidationCounter = 0
      this.hint = false
      this.updateCounter(validate.hasLength(password))
      this.updateCounter(validate.containsUppercaseCharacter(password))
      this.updateCounter(validate.containsLowercaseCharacter(password))
      this.updateCounter(validate.containsNumber(password))
      this.updateCounter(validate.containsValidSpecialCharacter(password))
      this.updateCounter(!validate.containsInvalidCharacter(password), true)
      this.updateAdditionalCounter(validate.hasName(password, this.firstName))
      this.updateAdditionalCounter(validate.hasName(password, this.lastName))
      this.updateAdditionalCounter(validate.hasName(password, this.userName))
      this.updateAdditionalCounter(validate.repetitiveAndSequenceCheck(password))
      if (this.hasInvalidChar) {
        this.strengthMeterCss = 'default-bar'
        this.passwordStrengthText = 'components.password.strengthMeter.invalid'
      } else {
        if (this.colorBar < 6) {
          this.strengthMeterCss = 'red-bar'
          this.passwordStrengthText = 'components.password.strengthMeter.weak'
        } else if (this.colorBar >= 6 && !this.additionValidationCounter) {
          this.strengthMeterCss = ''
          this.passwordStrengthText = 'components.password.strengthMeter.strong'
        } else if (this.colorBar >= 6 && this.additionValidationCounter) {
          this.strengthMeterCss = 'amber-bar'
          this.passwordStrengthText = 'components.password.strengthMeter.medium'
          this.hint = true
        } else {
          this.strengthMeterCss = 'default-bar'
          this.passwordStrengthText = 'components.password.strengthMeter.weak'
        }
      }
    },
    updateCounter (exp, inValidCharCheck = false) {
      if (exp) {
        this.colorBar++
        this.grayBar--
      }
      if (inValidCharCheck && exp) {
        this.hasInvalidChar = false
      }
    },
    updateAdditionalCounter (exp) {
      if (exp) {
        this.additionValidationCounter++
      }
    }
  },
  computed: {
    validCharacters: function () {
      return validate.validSpecialCharactersString()
    }
  }
}
</script>

<style scoped>
    .meter-container {
      height: 10px;
      width: 100%;
    }

    .valid_rule {
      height: 5px;
      width: 14%;
      float: left;
      background: green;
      margin-right: 2px;
    }

    .default-bar {
      height: 5px;
      width: 14%;
      float: left;
      background: #dcdcdc;
      margin-right: 2px;
    }

    .red-bar {
      background: red !important;
    }

    .amber-bar {
      background: #ffb045 !important;
    }

    .text-msg {
      float: right;
      font-size: 14px;
      colour: gray;
    }

    #rule-meter {
      width: 92%;
    }

    #rule-msg {
      width: 8%;
      float: left;
      font-family: DaimlerCS-Regular,sans-serif;
      color: gray !important;
      font-size: 14px;
      margin-top: -10px;
      text-align: right;
    }

    .hint-text {
      font-size: 13px;
      color: gray;
      text-align: left;
    }

    .clear-both {
      clear: both;
    }
</style>
